import '@/components/profileDropdown/styles/profile_dropdown.scss';

import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import classNames from 'classnames';

import { DEFAULT_BACKGROUND_COLOR, WHITE_BACKGROUND_COLOR } from '@/shared/Constants';
import useNavigation from '@/services/hocs/useNavigation';
import useResponsive from '@/services/hocs/useResponsive';

import DropdownWrapper from '@/components/dropdown/components/DropdownWrapper';
import Logo from '@/components/logo/Logo';
import ProfileAvatar from '@/components/profileDropdown/components/ProfileAvatar';
import ProfileButton from '@/components/profileDropdown/components/ProfileButton';

import type { ProfileDropdownProps } from '@/components/profileDropdown/types';

const ProfileDropdown = ({
	className = '',
	previewMode = false,
	userData,
}: ProfileDropdownProps) => {
	const { isMobile } = useResponsive();
	const { activeOption, navigationOptions, handleClickNavigation } = useNavigation() as any;

	const [isOpen, setIsOpen] = useState<boolean>(false);

	const { child_name, grade, profile_name } = userData || {};
	const { title: gradeTitle } = grade || {};

	const handleOpenDropdown = (open: boolean) => {
		setIsOpen(open);
		if (isMobile) {
			document.body.style.backgroundColor = isOpen
				? WHITE_BACKGROUND_COLOR
				: DEFAULT_BACKGROUND_COLOR;
		}
	};

	useEffect(() => {
		return () => {
			document.body.style.backgroundColor = DEFAULT_BACKGROUND_COLOR;
		};
	}, []);

	return (
		<DropdownWrapper
			optionValueKey="key"
			optionTitleKey="title"
			optionIconKey="icon"
			options={navigationOptions}
			menuPosition="left"
			onChange={handleClickNavigation}
			onActive={handleOpenDropdown}
			isActive={isOpen}
			className={classNames('profile-dropdown', className)}
			onlyAction
			disabled={previewMode}
			customHeader={<ProfileButton active={isOpen} />}
			showDrawer={isMobile}
			value={activeOption}
			optionsHeader={
				isMobile && (
					<>
						<div className="profile-dropdown__top">
							<Logo />
							<button
								className="profile-dropdown__close"
								type="button"
								onClick={() => handleOpenDropdown(false)}
							>
								<span className="icon icon-close" />
							</button>
						</div>
						<div className="profile-dropdown__header">
							<div className="profile-dropdown__header-info">
								<ProfileAvatar />
								<span className="profile-dropdown__header-name">
									{profile_name || child_name}
								</span>
								<span className="profile-dropdown__header-grade">{gradeTitle}</span>
							</div>
						</div>
					</>
				)
			}
		/>
	);
};

function mapStateToProps({ sharedReducer }: any) {
	return {
		userData: sharedReducer.userData,
	};
}

export default connect(mapStateToProps)(ProfileDropdown);
